/* GanzaX collection filters: size, orientation, category, price + sort, built from the prints on the page.
   Within a group options are OR; between groups AND. Each option shows how many prints it would leave,
   given the other active groups; options that would leave none are disabled. State lives in the URL. */
(() => {
  const root = document.querySelector('[data-gx-filters]');
  const list = document.querySelector('[data-gx-list]');
  if (!root || !list) return;

  const L = JSON.parse(root.querySelector('[data-gx-filter-labels]').textContent);
  const items = [...list.querySelectorAll('.gx-hang__item')].map((el) => ({
    el,
    index: Number(el.dataset.index),
    title: el.dataset.title || '',
    price: Number(el.dataset.price || 0),
    published: Number(el.dataset.published || 0),
    orient: el.dataset.orient,
    tags: (el.dataset.tags || '').split('|').filter(Boolean),
    sizes: (el.dataset.sizes || '').split('|').filter(Boolean),
  }));
  const total = items.length;

  const priceBuckets = { '0-500': [0, 50000], '500-1000': [50000, 100000], '1000-': [100000, Infinity] };
  // "60×90 cm", "60x90" and "60X90" are the same size (people type x in URLs).
  const sizeKey = (s) => s.replace(/\s*cm$/i, '').trim().replace(/\s*[xX×]\s*/, '×');
  const area = (s) => sizeKey(s).split(/[×x]/).reduce((a, b) => a * Number(b || 0), 1);

  /* Option lists from the catalogue itself */
  const groups = {
    size: [...new Set(items.flatMap((i) => i.sizes))].sort((a, b) => area(a) - area(b)).map((v) => ({ value: sizeKey(v), label: v })),
    orient: ['landscape', 'portrait', 'square'].filter((o) => items.some((i) => i.orient === o)).map((v) => ({ value: v, label: L.orient[v] })),
    cat: Object.keys(L.categories)
      .filter((t) => { const n = items.filter((i) => i.tags.includes(t)).length; return n > 0 && n < total; })
      .map((v) => ({ value: v, label: L.categories[v] })),
    price: Object.keys(priceBuckets)
      .filter((v) => items.some((i) => i.price >= priceBuckets[v][0] && i.price < priceBuckets[v][1]))
      .map((v) => ({ value: v, label: L.price[v] })),
  };
  const matchers = {
    size: (item, v) => item.sizes.some((s) => sizeKey(s) === v),
    orient: (item, v) => item.orient === v,
    cat: (item, v) => item.tags.includes(v),
    price: (item, v) => item.price >= priceBuckets[v][0] && item.price < priceBuckets[v][1],
  };
  const order = ['cat', 'size', 'orient', 'price'];

  /* State */
  const params = new URLSearchParams(location.search);
  const state = { sort: params.get('sort') || 'featured' };
  order.forEach((g) => {
    const valid = new Set(groups[g].map((o) => o.value));
    state[g] = new Set((params.get(g) || '').split(',').map((v) => (g === 'size' ? sizeKey(v) : v)).filter((v) => valid.has(v)));
  });

  const passes = (item, skip) =>
    order.every((g) => g === skip || state[g].size === 0 || [...state[g]].some((v) => matchers[g](item, v)));

  /* Build the panel once */
  const groupsEl = root.querySelector('[data-gx-groups]');
  order.forEach((g) => {
    if (groups[g].length < 2) return;
    const fs = document.createElement('fieldset');
    fs.className = 'gx-fgroup';
    fs.dataset.group = g;
    const lg = document.createElement('legend');
    lg.textContent = L.groups[g];
    fs.append(lg);
    const wrap = document.createElement('div');
    wrap.className = 'gx-fgroup__options';
    groups[g].forEach((o) => {
      const label = document.createElement('label');
      label.className = 'gx-chip';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.value = o.value;
      input.dataset.group = g;
      const text = document.createElement('span');
      text.textContent = o.label;
      if (g === 'size') text.dir = 'ltr';
      const n = document.createElement('small');
      n.className = 'gx-chip__count';
      label.append(input, text, n);
      wrap.append(label);
    });
    fs.append(wrap);
    groupsEl.append(fs);
  });

  const sortEl = root.querySelector('[data-gx-sort]');
  sortEl.value = state.sort;

  const sorters = {
    featured: (a, b) => a.index - b.index,
    'price-asc': (a, b) => a.price - b.price || a.index - b.index,
    'price-desc': (a, b) => b.price - a.price || a.index - b.index,
    new: (a, b) => b.published - a.published || a.index - b.index,
    title: (a, b) => a.title.localeCompare(b.title, 'he'),
  };

  function render() {
    const visible = items.filter((i) => passes(i));
    items.forEach((i) => (i.el.hidden = !visible.includes(i)));
    [...items].sort(sorters[state.sort] || sorters.featured).forEach((i) => list.append(i.el));

    root.querySelectorAll('.gx-chip input').forEach((input) => {
      const g = input.dataset.group;
      input.checked = state[g].has(input.value);
      const n = items.filter((i) => passes(i, g) && matchers[g](i, input.value)).length;
      input.disabled = n === 0 && !input.checked;
      input.closest('.gx-chip').querySelector('.gx-chip__count').textContent = n;
    });

    root.querySelector('[data-gx-count]').textContent = visible.length;
    root.querySelector('[data-gx-apply]').textContent = L.show.replace('%n', visible.length);
    document.querySelector('[data-gx-empty]')?.toggleAttribute('hidden', visible.length > 0);

    const active = order.flatMap((g) => [...state[g]].map((v) => ({ g, v })));
    const badge = root.querySelector('[data-gx-active-count]');
    badge.hidden = active.length === 0;
    badge.textContent = active.length;
    const chips = root.querySelector('[data-gx-chips]');
    chips.hidden = active.length === 0;
    chips.replaceChildren(
      ...active.map(({ g, v }) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gx-chip gx-chip--active';
        const label = groups[g].find((o) => o.value === v)?.label || v;
        b.setAttribute('aria-label', `${L.remove} ${label}`);
        b.innerHTML = '<span></span><span aria-hidden="true">×</span>';
        b.firstChild.textContent = label;
        if (g === 'size') b.firstChild.dir = 'ltr';
        b.addEventListener('click', () => { state[g].delete(v); update(); });
        return b;
      })
    );

    const url = new URL(location.href);
    order.forEach((g) => (state[g].size ? url.searchParams.set(g, [...state[g]].join(',')) : url.searchParams.delete(g)));
    state.sort !== 'featured' ? url.searchParams.set('sort', state.sort) : url.searchParams.delete('sort');
    history.replaceState(history.state, '', url);
  }

  // View transitions make the reflow read as the same prints moving, where supported.
  const update = () => (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches
    ? document.startViewTransition(render).ready.catch(() => {})
    : render());

  groupsEl.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.dataset.group) return;
    input.checked ? state[input.dataset.group].add(input.value) : state[input.dataset.group].delete(input.value);
    update();
  });
  sortEl.addEventListener('change', () => { state.sort = sortEl.value; update(); });
  document.querySelectorAll('[data-gx-clear]').forEach((b) => b.addEventListener('click', () => {
    order.forEach((g) => state[g].clear());
    update();
  }));

  /* Phone: the panel is a bottom sheet */
  const panel = root.querySelector('[data-gx-panel]');
  const backdrop = root.querySelector('.gx-fpanel__backdrop');
  const opener = root.querySelector('[data-gx-filters-open]');
  const sheet = matchMedia('(max-width: 989px)');
  const open = () => {
    panel.classList.add('is-open');
    backdrop.hidden = false;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('gx-sheet-open');
    panel.querySelector('input:not(:disabled), button')?.focus();
  };
  const close = () => {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    backdrop.hidden = true;
    panel.setAttribute('role', 'group');
    panel.removeAttribute('aria-modal');
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('gx-sheet-open');
    opener.focus();
  };
  opener.addEventListener('click', open);
  root.querySelectorAll('[data-gx-filters-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  sheet.addEventListener('change', () => { if (!sheet.matches) close(); });

  render();
})();
